<div class="quote">
  <h3
    class="quote__headline"
    [innerHTML]="quote_headline"
    *ngIf="quote_headline"
  ></h3>
  <div class="quote__inner">
    <div class="quote__icon">
      <hdi-icon
        [color]="color.GREEN_LIGHT"
        [size]="size.XXLARGE"
        [iconName]="'quote-right'"
        [iconPrefix]="'fas'"
      ></hdi-icon>
    </div>
    <div class="quote__content">
      <p class="quote__text" [innerHTML]="quote" *ngIf="quote"></p>
      <div class="quote__meta" *ngIf="quote_name || quote_subline">
        <p class="quote__name" [innerHTML]="quote_name" *ngIf="quote_name"></p>
        <p
          class="quote__subline"
          [innerHTML]="quote_subline"
          *ngIf="quote_subline"
        ></p>
      </div>
    </div>
  </div>
</div>
